import { ChangeDetectorRef, Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class HelperService {
    
    constructor() {}
    
    /**
     * Scrolls to a html element 
     *  
     * @param id id of the html element
     */
    scrollTo(id: string, changeDetector: ChangeDetectorRef) {
        changeDetector.detectChanges();
        document?.getElementById(id)?.scrollIntoView();
    }
}